import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell/rules")({
  beforeLoad: () => {
    throw redirect({ to: "/behaviour-studio", replace: true });
  },
});
